import { Component } from '@angular/core';

@Component({
  selector: 'prime-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent {
  constructor() {}
}
